import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  getUsers,
  getUsersSuccess,
  getCurrentUser,
  getCurrentUserSuccess,
  getUsersFailure,
} from "./actions";
import { getAiHealthRequest, getUserRequest } from "./api";
import { Response, User } from "./types";
import _ from "lodash";
import { isStrapi } from "src/api/config/systemSwitch";
import { prefix } from "src/utils/users.utils";
import { authService } from "../authMobile/authService";
import { Preferences } from '@capacitor/preferences';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { isPWA } from "src/utils/mobile";

function* usersSaga(action: { type: string; payload: [] }) {
  try {
    let { payload } = action;
    let usersIdRequests: any[] = [];
    let arrUsersEmail = _.uniqWith(payload, _.isEqual);
    if (arrUsersEmail.length > 0) {
      if (!isStrapi) {
        arrUsersEmail.forEach((item: any) => {
          usersIdRequests = [...usersIdRequests, call(getUserRequest, [item])];
        });
      }
    }
    let users: User[] = [];
    if (isStrapi) {
      users = yield call(getUserRequest, arrUsersEmail);
    } else {
      users = yield all(usersIdRequests);
    }
    const managersArrEmails = users.map((user) => {
      const managerAccount =
        (user["UserProfileProperties"].length > 0 &&
          user["UserProfileProperties"].find(
            (item: any) => item.Key === "Manager"
          )?.["Value"]) ||
        "";
      if (managerAccount) {
        const managerEmail =
          (managerAccount.split("|").length > 0 &&
            managerAccount
              .split("|")
            [managerAccount.split("|").length - 1].toLowerCase()) ||
          "";
        return managerEmail;
      } else {
        return "";
      }
    });
    if (managersArrEmails.length > 0) {
      let arrManagersEmail = _.uniqWith(managersArrEmails, _.isEqual).filter(
        (email) => email !== ""
      );
      if (arrManagersEmail.length > 0) {
        users = [...users, ...(yield call(getUserRequest, arrManagersEmail))];
      }
    }
    const usersObj: any = {};
    users.forEach((user: any) => {
      if (user && user.Email) {
        const Email = user.AccountName.split("|")
        [user.AccountName.split("|").length - 1].toLowerCase()
          .trim();
        usersObj[Email] = user;
      }
    });

    yield put(getUsersSuccess(usersObj));
  } catch (e) {
    yield put(getUsersFailure());
    console.log(e);
  }
}

function* getCurrentUserSaga(action) {
  try {
    let user;
    if (isPWA()) {
      user = window.strapiUser
    } else {
      const { value: token } = yield call(
        [SecureStoragePlugin, SecureStoragePlugin.get],
        { key: 'accessToken' }
      );

      // получаем пользователя через API
      const userApp = yield call(authService.getUser, token);

      user = userApp;
    }

    const response: Response = {
      AccountName: prefix + user.email,
      DirectReports: [],
      DisplayName: user.DisplayName,
      Id: user.id,
      Email: user.email,
      ExtendedManagers: {
        results:
          (user.ExtendedManagers &&
            Array.isArray(user.ExtendedManagers) &&
            user.ExtendedManagers.length > 0 &&
            user.ExtendedManagers.map((item) => prefix + item)) ||
          [],
      },
      Peers: {
        results:
          (user.Peers &&
            Array.isArray(user.Peers) &&
            user.Peers.length > 0 &&
            user.Peers.map((item) => prefix + item)) ||
          [],
      },
      PictureUrl: "",
      PreferredName: user.DisplayName,
      Title: user.DisplayName,
      UserProfileProperties: [],
      Groups: [],
      Roles: [],
    };

    let email = response.AccountName.split("|")
    [response.AccountName.split("|").length - 1].toLowerCase()
      .trim();

    let arrayEmail: string[] = [];

    arrayEmail = [...arrayEmail, email];
    arrayEmail = [...arrayEmail, "supply.portal@abinbevefes.com"];

    const users: User[] = yield call(getUserRequest, arrayEmail);
    // const aiEnabled = yield call(getAiHealthRequest);
    const usersObj = users.reduce<Record<string, User>>((result, user) => {
      if (!user?.AccountName) {
        return result;
      }

      const accountParts = user.AccountName.split("|");
      const userEmail = accountParts[accountParts.length - 1]?.toLowerCase().trim();
      return userEmail ? { ...result, [userEmail]: user } : result;
    }, {});
    yield put(getUsersSuccess(usersObj));

    const groups = users
      .filter((el) => el.Id)[0]
    ["Roles"].map((group: any) => {
      return { Id: group.id };
    });
    const roles = users
      .filter((el) => el.Id)[0]
    ["Roles"].filter((role: any) => role.Role)
      .map((group: any) => {
        return {
          ID: group.id,
          Role: group.Role,
          Collection:
            (group.MDCollection && { ID: group.MDCollection.id }) || null,
          LocationMyTasks:
            (group.MTLocation && { ID: group.MTLocation.id }) || null,
        };
      });
    response.Id = users.filter((el) => el.Id)[0]["Id"];
    response.Email = users.filter((el) => el.Id)[0]["Email"];
    response.Groups = groups;
    response.Roles = roles;
    response.PictureUrl = users.filter((el) => el.Id)[0]["PictureUrl"];
    response.DirectReports = users.filter((el) => el.Id)[0]["DirectReports"];
    response.AccountName = users.filter((el) => el.Id)[0]["AccountName"];
    response.aiEnabled = true; //aiEnabled;
    response["UserProfileProperties"] = users.filter((el) => el.Id)[0][
      "UserProfileProperties"
    ];


    yield put(getCurrentUserSuccess(response));

  } catch (e) {
    console.log("getCurrentUserSaga error", e);
  }
}

export function* usersWatcher() {
  yield takeLatest(getUsers.toString(), usersSaga);
}

export function* currentUserWatcher() {
  yield takeLatest(getCurrentUser.toString(), getCurrentUserSaga);
}
